
    var riot = require('riot')
    //src: starling/src/tags/region.html
riot.tag2('region',
  '<div class="region {this.isSelected ? \'selected\' : \'\'}" data-move-enabled="{this.moveEnabled ? \'true\' : \'false\'}" riot-style="{getStyle()}" ref="main" oncontextmenu="{summonMenu}" onmouseenter="{handleRegionMouseEnter}" onmouseleave="{handleRegionMouseLeave}" data-region-id="{this.id}"> <div ref="regionScreen" class="region-screen panzoomable selection-area-enabled" riot-style="{getScreenStyle()}"></div> <div if="{showTools()}" class="region-resize-handle region-resize-handle--top-edge region-resize-handle--top" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{showTools()}" class="region-resize-handle region-resize-handle--left-edge region-resize-handle--left" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{showTools()}" class="region-resize-handle region-resize-handle--bottom-edge region-resize-handle--bottom" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{showTools()}" class="region-resize-handle region-resize-handle--right-edge region-resize-handle--right" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--top region-resize-handle--left" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--top region-resize-handle--right" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--bottom region-resize-handle--left" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--bottom region-resize-handle--right" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--top-middle region-resize-handle--top" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--left-middle region-resize-handle--left" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--bottom-middle region-resize-handle--bottom" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div if="{resizeEnabled}" class="region-resize-handle region-resize-handle--right-middle region-resize-handle--right" onmouseenter="{showEdgeHandles}" onmouseleave="{hideEdgeHandles}"></div> <div ref="dragArea" class="region-draggable-bar {showTools() ? \'drag-handle\' : \'\'}"></div> <div ref="titleContainer" class="title-wrapper"> <h3 class="region_title focusable title" spellcheck="false" contenteditable="{this.opts.canvas.isViewOnly() ? \'false\' : \'true\'}" ref="title" onkeydown="{handleTitleKeydown}" onkeyup="{stopPropagation}" onpaste="{handlePaste}" onclick="{handleTitleClick}" ondblclick="{handleTitleDoubleClick}" onblur="{saveTitle}" data-region-id="{this.id}">{title}</h3> <h3 class="region_title title text-highlight-layer" ref="highlightTitle"></h3> <i if="{showTools()}" class="material-icons title-kebab" ref="menuTrigger" onclick="{summonMenu}">more_vert</i> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _util = require('lib/util');

var _nodesUi = require('lib/nodes-ui');

var _selectionUi = require('lib/selection-ui');

var _constants = require('lib/constants');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _regionUi = require('lib/region-ui');

var _collaboratorsUi = require('lib/collaborators-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.instance = store.getRegion(this.id);
var canvas = opts.canvas;
this.resizeEnabled = false;
this.moveEnabled = false;
this.isInteractable = false;
canvas.regionTags[this.id] = this;

this.on('mount', function () {
  var main = _this.refs.main;

  _this.enableMovement();
  _this.setTextSizeAttribute();
  canvas.triggerPostinitialization();
  $(_this.refs.title).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });

  if (_this.showTools()) {
    $(_this.refs.dragArea).on('mousedown touchstart pointerdown', function (e) {
      canvas.hidePopups();
    });
    (0, _interactjs2.default)(_this.refs.dragArea).on('tap', function (e) {
      /* don't deselect if right clicking or ctrl+clicking */
      if (e.button && e.button === 2) return;
      if (e.ctrlKey) return;
      _this.toggleSelected(e);
    });
  }
});

this.on('update', function () {
  _this.setTextSizeAttribute();
});

this.getStyle = function () {
  var _opts$canvas$getMatri = _this.opts.canvas.getMatrix(),
      scale = _opts$canvas$getMatri.scale;

  var backgroundOpacity = _this.getBackgroundOpacity() / 255;

  return '\n        width: ' + (_this.instance.right - _this.instance.left) + 'px;\n        height: ' + (_this.instance.bottom - _this.instance.top) + 'px;\n        left: ' + _this.instance.left + 'px;\n        top: ' + _this.instance.top + 'px;\n        --region-lightened-color: ' + (_this.instance && _this.instance.color ? (0, _util.shade)(_this.instance.color, 0.85) : 'transparent') + ';\n        --region-color: ' + _this.instance.color + ';\n        --region-background-color: ' + (_this.instance && _this.instance.color ? (0, _util.shade)((0, _util.shade)(_this.instance.color, 0.97 - backgroundOpacity), -0.02) : 'transparent') + ';\n        --region-zoom-background-color: ' + (_this.instance && _this.instance.color ? (0, _util.shade)((0, _util.shade)(_this.instance.color, 0.97 - backgroundOpacity), -0.02) + 'bb' : 'transparent') + ';\n        --text-shadow-color: var(--region-background-color);\n        ' + (_this.borderHighlightColor ? '--region-border-highlight-color: ' + _this.borderHighlightColor : '') + ';\n        ' + (_this.borderHighlightColor ? 'border: 2px solid var(--region-border-highlight-color)' : '') + ';\n      ';
};

this.getScreenStyle = function () {
  return 'background: ' + _this.getBackgroundStyle() + ';';
};

this.getBackgroundOpacity = function () {
  var _opts$canvas$getMatri2 = _this.opts.canvas.getMatrix(),
      scale = _opts$canvas$getMatri2.scale;

  return Math.max(Math.floor(8 + (1.2 - scale) * 16), 10);
};

this.getBackgroundStyle = function () {
  var backgroundOpacityHex = String(_this.getBackgroundOpacity()).padLeft(2, "0");
  return '' + _this.instance.color + backgroundOpacityHex;
};

this.onResize = function (_ref) {
  var rect = _ref.rect,
      deltaRect = _ref.deltaRect;

  if (canvas.isViewOnly()) return;
  _regionUi.regionUI.applyResize({
    region: _this.instance,
    rect: (0, _util.scaleRect)({ rect: rect, canvas: canvas })
  });
  _this.instance.applyunSnappedResize((0, _util.scaleRect)({ rect: rect, canvas: canvas }));

  _this.update();
};

this.onMoveStart = function (e) {
  if (canvas.isViewOnly()) return;
  _this.onResizeMoveStart(e);
  if (!_this.isSelected) {
    canvas.clearSelectedElements();
  }

  _regionUi.regionUI.resetDragData();
  _regionUi.regionUI.prepareSelectedRegionsForMove();
  _regionUi.regionUI.setPrevRegionPosition(_this.instance);
  _regionUi.regionUI.addDraggableRegions([_this.instance]);
  _regionUi.regionUI.prepareSelectedNodesForMove();
  canvas.multiSelectionIndicatorBox.hide();
};

this.getMoveableCardsInRegion = function (region) {
  var nodes = _selectionUi.selectionUI.getNodesInsideBox(region);
  return nodes.filter(function (n) {
    return !n.parentId && !n.link();
  });
};

this.onResizeMoveStart = function (e) {
  if (canvas.isViewOnly()) return;
  e.stopPropagation();
  _this.prevValues = {
    top: _this.instance.top,
    left: _this.instance.left,
    right: _this.instance.right,
    bottom: _this.instance.bottom
  };
};

this.onResizeMoveEnd = function (e) {
  if (canvas.isViewOnly()) return;
  e.stopPropagation();
  canvas.operation.updateRegion({
    regionUUID: _this.id,
    prevValues: _this.prevValues,
    updates: {
      top: _this.instance.top,
      left: _this.instance.left,
      right: _this.instance.right,
      bottom: _this.instance.bottom
    },
    onFailure: console.warn
  });
};

this.onMoveEnd = function (e) {
  if (canvas.isViewOnly()) return;
  e.stopPropagation();
  if (!_this.moveEnabled) return;
  canvas.selectionArea.selectionDisabled = false;
  var operationMessages = [];
  var message = _regionUi.regionUI.getRegionPositionOperationMessage(_this.instance);
  operationMessages.push(message);

  _regionUi.regionUI.applyRegionPositionOperations({ operationMessages: operationMessages });

  _regionUi.regionUI.applyNodePositionOperations({ operationMessages: operationMessages });

  canvas.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.log('Region move batchOperation failure: ' + err);
    }
  });
  _regionUi.regionUI.resetDragData();
  canvas.multiSelectionIndicatorBox.update();
};

this.onMove = function (_ref2) {
  var dx = _ref2.dx,
      dy = _ref2.dy,
      stopPropagation = _ref2.stopPropagation;

  if (canvas.isViewOnly()) return;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  var instance = _this.instance;
  var top = instance.top,
      left = instance.left;

  dx = dx / scale;
  dy = dy / scale;

  _regionUi.regionUI.applyMove({ dx: dx, dy: dy, draggingRegion: instance, dontSnap: _regionUi.regionUI.draggingRegions.length > 1 });
  instance.applyunSnappedMove({ dx: dx, dy: dy });

  _regionUi.regionUI.applyMoveToRegions({ dx: dx, dy: dy, excludeRegions: [_this.id] });

  var newTop = instance.top,
      newLeft = instance.left;

  var actualDx = newLeft - left;
  var actualDy = newTop - top;

  _regionUi.regionUI.applyMoveToNodes({ dx: actualDx, dy: actualDy });

  _this.update();
};

this.makeNotInteractable = function () {
  (0, _interactjs2.default)(_this.refs.main).unset();
};

this.handleTitleClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
  canvas.hidePopups();
  _this.refs.title.focus();
  _this.initialTitle = _this.instance.title;
  _collaboratorsUi.cui.sendPresence();
};

this.handleTitleDragClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
  canvas.hidePopups();
};

this.handleTitleDoubleClick = function (e) {
  e.stopPropagation();
};

this.showTools = function () {
  if (canvas.isViewOnly()) return false;
  return true;
};

this.enableResize = function () {
  if (canvas.isViewOnly()) return;
  _this.resizeEnabled = true;
  _this.update();
};

this.disableResize = function () {
  _this.resizeEnabled = false;
  _this.update();
};

this.enableMovement = function () {
  if (canvas.isViewOnly()) return;
  _this.moveEnabled = true;
  _this.isInteractable = true;
  _this.update();
};

this.saveTitle = function () {
  if (_this.instance.title !== _this.refs.title.innerText.trim()) {
    canvas.operation.updateRegion({
      regionUUID: _this.id,
      prevValues: { title: _this.instance.title },
      updates: {
        title: _this.refs.title.innerText.trim()
      },
      onFailure: console.warn
    });
    _this.instance.setTitle(_this.refs.title.innerText.trim());
  }
  _collaboratorsUi.cui.dismissElementChangedBanner();
  _collaboratorsUi.cui.sendPresence();
};

this.summonMenu = function (e) {
  if (canvas.isViewOnly()) return;
  if (e.altKey) return;
  e.stopPropagation();
  e.preventDefault();

  canvas.regionMenu.summon({
    referenceEl: _this.refs.menuTrigger,
    id: _this.id,
    regionTag: _this,
    fromRightClick: e.button && e.button === 2,
    position: {
      x: e.clientX,
      y: e.clientY
    }
  });
};

this.handleTitleMouseLeave = function (e) {
  if (!_this.refs.title.focused) {}
};

this.handleRegionMouseEnter = function (e) {
  if (_this.isInteractable) return;
};

this.handleRegionMouseLeave = function (e) {
  canvas.selectionArea.resetSelectionAreaTarget();
};

this.handleTitleKeydown = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  if (e.keyCode === _constants.KEY_CODES.ENTER) {
    e.preventDefault();
    e.stopPropagation();
    _this.refs.title.blur();
  }
};

this.stopPropagation = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};

/* allow us to update elements without clobbering other users' current actions in the region */
this.refreshTitle = function () {
  _this.refs.title.innerText = _this.instance.title.trim();
};

this.refreshColor = function () {
  var _refs = _this.refs,
      main = _refs.main,
      regionScreen = _refs.regionScreen;

  var backgroundOpacity = _this.getBackgroundOpacity() / 255;
  main.style.color = _this.instance.color;
  main.style.setProperty('--region-lightened-color', (0, _util.shade)(_this.instance.color, 0.85));
  main.style.setProperty('--region-color', _this.instance.color);

  main.style.setProperty('--region-background-color', _this.instance && _this.instance.color ? (0, _util.shade)((0, _util.shade)(_this.instance.color, 0.97 - backgroundOpacity), -0.02) : 'transparent');
  main.style.setProperty('--region-zoom-background-color', _this.instance && _this.instance.color ? (0, _util.shade)((0, _util.shade)(_this.instance.color, 0.97 - backgroundOpacity), -0.02) + 'bb' : 'transparent');
  main.style.setProperty('--text-shadow-color', 'var(--region-background-color)');

  if (_this.borderHighlightColor) {
    main.style.setProperty('--region-border-highlight-color', _this.borderHighlightColor);
    main.style.border = '2px solid var(--region-border-highlight-color)';
  } else {
    main.style.removeProperty('--region-border-highlight-color');
  }
  regionScreen.style.background = _this.getBackgroundStyle();
};

this.refreshPosition = function () {
  var main = _this.refs.main;
  var instance = _this.instance;

  main.style.width = instance.right - instance.left + 'px';
  main.style.height = instance.bottom - instance.top + 'px';
  main.style.left = instance.left + 'px';
  main.style.top = instance.top + 'px';
};

this.toggleSelected = function (e) {
  var isMac = canvas.isMac;

  var metaKeyPushed = isMac && e.metaKey || !isMac && e.ctrlKey;

  _selectionUi.selectionUI.resetNodeRects();

  if (_this.isSelected && !metaKeyPushed) {
    _regionUi.regionUI.removeRegionFromSelection(_this.id);
  } else {
    _regionUi.regionUI.selectRegion(_this.id, e.shiftKey);
    if (metaKeyPushed) {
      _selectionUi.selectionUI.selectAllInsideBox(_this.instance, e.shiftKey);
      return;
    }
  }

  if (!e.shiftKey) {
    canvas.clearSelectedElements({ dontClearRegions: true });
  } else {
    canvas.updateSelectedState();
  }
};

this.setSelected = function () {
  if (!_this.isSelected) {
    _this.isSelected = true;
    _this.enableMovement();
    canvas.bulkActionsMenuTag.update();
  }

  if (canvas.getSelectedElementsCount() > 1) {
    _this.disableResize();
  } else {
    _this.enableResize();
  }
};

this.deSelect = function () {
  if (_this.isSelected) {
    _this.isSelected = false;
    _this.disableResize();
    canvas.bulkActionsMenuTag.update();
  }
};

this.showEdgeHandles = function () {
  if (canvas.getSelectedElementsCount() <= 1) {
    _this.enableResize();
  }
};

this.hideEdgeHandles = function () {
  if (!_this.isSelected) {
    _this.disableResize();
  }
};

this.getZoomTextClass = function () {
  var _instance = _this.instance,
      left = _instance.left,
      right = _instance.right,
      top = _instance.top,
      bottom = _instance.bottom,
      title = _instance.title;

  var width = right - left;
  var height = bottom - top;
  var minDim = Math.min(width, height);
  var squarePtSize = Math.sqrt(minDim * minDim / (title ? title.length : 1));
  var ptSize = squarePtSize * 0.5;

  return ptSize > 120 ? 120 : ptSize > 80 ? 80 : ptSize > 60 ? 60 : 40;
};

this.setTextSizeAttribute = function () {
  var zoomTextClass = _this.getZoomTextClass();
  _this.refs.title.setAttribute('data-zoom-text-size', zoomTextClass);
  _this.refs.highlightTitle.setAttribute('data-zoom-text-size', zoomTextClass);
};

this.handlePaste = function (e) {
  e.preventDefault();
  if (canvas.isViewOnly()) return;
  var text = (0, _util.convertNewlines)((0, _escapeHtml2.default)(e.clipboardData.getData('text/plain')));
  document.execCommand('insertHTML', false, text);
};

this.setLocalBorderHighlightColor = function (color) {
  if (_this.refs.main) {
    _this.borderHighlightColor = color;
    _this.refs.main.style.setProperty('--region-border-highlight-color', color);
    _this.refs.main.style.border = '2px solid var(--region-border-highlight-color)';
  }
};

this.unsetLocalBorderHighlightColor = function () {
  if (_this.refs.main) {
    _this.borderHighlightColor = null;
    _this.refs.main.style.removeProperty('--region-border-highlight-color');
    _this.refs.main.style.border = '';
  }
};

this.shuttleCursorToTitle = function (user) {
  _collaboratorsUi.cui.shuttleCursorToField(user, _this.refs.titleContainer);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('region')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/region.html
// module id = 742
// module chunks = 0